import { useState } from "react";
import { Button } from "react-bootstrap";
import SignatureModal from "./signature-modal";

const SignButton = () => {
	const [openSignModal, setOpenSignModal] = useState(false);

	return (
		<div>
			<Button
				className="btn-fill"
				onClick={() => {
					setOpenSignModal(true);
				}}
			>
				<i className="bi bi-vector-pen me-0"></i>
				Ký số
			</Button>

			{openSignModal && (
				<SignatureModal open={openSignModal} onClose={() => setOpenSignModal(false)} />
			)}
		</div>
	);
};

export default SignButton;
